import "./documents.scss";
import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { GetDocumentThumbUrl, FetchDocumentObjectUrl, SaveBlobAs } from "../../services/documentService";
import DocumentPreviewModal from "../DocumentPreviewModal/DocumentPreviewModal";
import { DeleteDocument } from "../../services/noteBookService";
import IconButton from "../iconButton/iconButton";
import Confirm from "../confirm/confirm";
import AstrixIcon from "../../assets/images/astrix.svg";
import EditIcon from "../../assets/images/edit.svg";
import DeleteIcon from "../../assets/images/delete.svg";
import Loading from "../../assets/images/loadingGreen16.svg";
import PDF from "../../assets/images/pdf.svg";

export default function Documents({documents, onManipulation}) {
  const [editDocumentId, setEditDocumentId] = useState("");
  const [deleteDocumentId, setDeleteDocumentId] = useState("");
  const [deletLoading, setDeletLoading] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [thumbs, setThumbs] = useState({}); // { [docId]: objectUrl }
  const [previewOpen, setPreviewOpen] = useState(false);
  const [preview, setPreview] = useState(null); 
  const [activeIndex, setActiveIndex] = useState(-1);
  const [previewLoading, setPreviewLoading] = useState(false);

  const inflightRef = useRef(new Set());
  const thumbsRef = useRef({});

  useEffect(() => {
    thumbsRef.current = thumbs;
  }, [thumbs]);

  useEffect(() => {
    let alive = true;

    async function loadThumbs() {
      // فقط برای سندهایی که هنوز thumb ندارن
      const missing = (documents || []).filter((d) => !thumbsRef.current[d.ID]);
      for (const document of missing) {
        if (inflightRef.current.has(document.ID)) continue;
        inflightRef.current.add(document.ID);
        try {
          const url = await GetDocumentThumbUrl(document.ID);
          if (!alive) return;
          if (url) setThumbs((prev) => ({ ...prev, [document.ID]: url }));
        } catch (err) {
          toast.error(err?.error || "خطا در دریافت thumbnail", { toastId: "thumb-error" });
        } finally {
          inflightRef.current.delete(document.ID);
        }
      }
    }

    if (documents?.length) loadThumbs();

    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documents]);

  // پاکسازی objectUrl ها وقتی لیست عوض میشه/کامپوننت unmount میشه
  useEffect(() => {
    return () => {
      Object.values(thumbsRef.current).forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);

  const openPreview = async (document, index) => {
    try {
      setPreviewLoading(true);
      if (preview?.url) URL.revokeObjectURL(preview.url);
      const { url, blob, filename } = await FetchDocumentObjectUrl(document.ID);
      const fallbackName = document.originalName || document.OriginalName || document.title || document.Title || `document-${document.ID}`;
      setPreview({ document, url, blob, filename: filename || fallbackName });
      setActiveIndex(index);
      setPreviewOpen(true);
    } catch (err) {
      toast.error(err?.error || "خطا در باز کردن فایل");
    } finally {
      setPreviewLoading(false);
    }
  };

  const openByIndex = async (index) => {
    if (!documents?.length) return;
    if (index < 0 || index >= documents.length) return;
    await openPreview(documents[index], index);
  };

  const onPrev = () => openByIndex(activeIndex - 1);

  const onNext = () => openByIndex(activeIndex + 1);

  const closePreview = () => {
    if (preview?.url) URL.revokeObjectURL(preview.url);
    setPreview(null);
    setPreviewOpen(false);
    setActiveIndex(-1);
    setPreviewLoading(false);
  };

  const downloadFromPreview = () => {
    if (!preview?.blob) return;
    SaveBlobAs(preview.blob, preview.filename);
  };

  

  return (
    <div className="documents">
      <DocumentPreviewModal
        open={previewOpen}
        onClose={closePreview}
        fileUrl={preview?.url}
        mimeType={preview?.document?.mimeType || preview?.document?.MimeType}
        onDownload={downloadFromPreview}
        onPrev={onPrev}
        onNext={onNext}
        hasPrev={activeIndex > 0}
        hasNext={activeIndex < (documents?.length || 0) - 1}
        loading={previewLoading}
        fileTitle={preview?.document.title}
        fileDescription={preview?.document.description}
      /> 
      {documents?.length > 0 &&
        documents.map((document, index) => {
          return (
            <div className={`documentWrapper ${editDocumentId === document.ID ? "editing" : ""}`} key={document.ID}>
              <div className="docTitle">
                {document.title || document.Title}
              </div>
              {document.mimeType === "application/pdf" ||
                document.MimeType === "application/pdf" ? (
                  <div
                    className="pdfThumb"
                    onClick={() => openPreview(document, index)}
                  >
                   <img src={PDF} className="pdfIcon" alt="loading" />
                  </div>
                ) : thumbs[document.ID] ? (
                  <img
                    src={thumbs[document.ID]}
                    alt="thumb"
                    className="docThumb"
                    onClick={() => openPreview(document, index)}
                  />
                ) : (
                  <img src={Loading} alt="loading" />
              )}
              <div className="docDescription">
                {document.description || document.Description}
              </div>
            </div>
          )
        })
      }
    </div>
  );
}
